import React, { memo, useEffect, useRef } from "react";
import { classNames, useTranslate } from "helpers";
import { ReactSVG } from "react-svg";
import { VehiclePictureSummaryProps } from "./types";

const VehiclePictureSummary: React.FC<VehiclePictureSummaryProps> = ({
  vehicleInfo,
  stepCurrent,
}) => {
  const { t } = useTranslate();
  const thisStep = 7;

  const isActive = stepCurrent === thisStep;
  const isCompleted = stepCurrent > thisStep;

  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (isActive) {
      ref.current?.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [isActive]);

  if(!isActive && !isCompleted)
    return null;

  return (
    <div
      ref={ref}
      className={classNames(
        `
        bg-white rounded-md border border-blue-100 shadow-xl
      w-[280px] h-[260px]
        flex-shrink-0
        snap-start
        transition-all duration-300
        cursor-pointer
        `,
        isActive
          ? "opacity-100 scale-100 ring-2 ring-blue-500"
          : "opacity-70 hover:opacity-100 "
      )}
    >
          <div className="p-3 flex justify-between items-center min-h-[52px]">
        <h3 className="text-sm font-semibold text-slate-800">
          {thisStep + 1}. Slike
        </h3>

        {isCompleted && (
          <div className="bg-green-50 border-2 border-green-500 rounded-full p-1">
            <ReactSVG
              src="/media/icons/check.svg"
              className="w-4 h-4 fill-green-500 stroke-green-500"
            />
          </div>
        )}
      </div>

      <div className="border-t border-slate-200 p-2">
        {vehicleInfo.pictureUrls.length > 0 ? (
          <div className="grid grid-cols-4 gap-1.5">
            {vehicleInfo.pictureUrls.map((url, i) => (
              <img
                key={i}
                src={url}
                alt=""
                className="w-full aspect-square rounded-sm object-cover"
              />
            ))}
          </div>
        ) : (
          <div className="flex items-center justify-center h-[120px]">
            <p className="text-sm text-slate-400">Nema slika</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default memo(VehiclePictureSummary);
